export const events: Record<string, string> = {
	event_BOX_IS_EMPTY: "A caixa estava vazia.",
	event_CANT_HEAL_ALREADY_FULL_HEALTH: "Você já está com vida 100%.",
	event_CANT_PUT_MINE_HERE: "Não pode colocar uma mina aqui.",
	event_CONTAINER_OPENS: "Você abriu a caixa.",
	event_DEV_KILL_BOT_ACTIVATED: "Auto kill activated.",
	event_DEV_KILL_BOT_DEACTIVATED: "Auto kill deactivated.",
	event_DO_NOT_HAVE_KEY: "Você precisa de uma chave para abrir esta caixa.",
	event_EQUATION_FOUND: "Você encontrou a equação!",
	event_EQUATION_IS_HERE: "A equação está aqui! Você só precisa olhar mais de perto...",
	event_GOT_AMMO: "Obteve $1x",
	event_GOT_ITEM: "Obteve $1x",
	event_GOT_WEAPON: "Obteve ",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_1: "Mais inimigos estão vindo.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_2: "Este local está ficando perigoso.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_3: "Ainda mais inimigos se aproximam.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_4: "Eles estão muito irritados e estão enviando reforços.",
	event_LEVEL_DIRECTOR_HOSTILITY_REACHED_5: "SANGUE PARA O DEUS DO SANGUE!",
	event_NO_PATH_FOR_AUTOMOVE: "Você não sabe como chegar lá.",
	event_PLAYER_DIED: "Você morreu.",
	event_PLAYER_FULLY_HEALED: "Você agora está completamente curado!",
	event_PLAYER_HEALED: "Você curou seus machucados.",
	event_POWER_PLANT_ACTIVATED: "Usina agora online.",
	event_POWER_PLANT_GATE_NO_POWER: "Não é possível abrir as portas. Sem energia.",
	event_POWER_PLANT_GATE_NO_KEYCARD: "Cartão de acesso necessário.",
	event_POWER_PLANT_GATE_OPENED: "Abrindo portões...",
	event_VENDING_MACHINE_NO_POWER: "Sem energia",
	event_TERMINAL_NO_POWER: "Sem energia",
	event_TERMINAL_NO_KEYCARD: "Cartão de acesso necessário.",
	event_FIRST_WEAPON_PICKUP: "",
	event_LOW_HP_MEDIKIT_HINT: "",
	event_HINT: "",
	event_REACHED_AREA: "Você chegou em: $1",
	event_TERMINAL_OPENED_BLAST_DOORS: "Você acessa o terminal. As portes de segurança se abrem!",
};
